export const selectsName = {
  proListCtrl: 'proListCtrl',
  buListId: 'buListId',
  categoryListId: 'categoryListId',
  regionListCtrl: 'regionListCtrl',
}
